/**
 * The two ways a customer can stand towards one class of features (Fusion
 * capabilities, map layers, base maps), named the same everywhere they are
 * shown: the per-class select, the headline sentence, the footer's change
 * list, the tab's badge. "Open" is the default and needs no maintenance;
 * "Only what's listed" is the exception a few customers are on.
 */
export const ACCESS_MODE_LABEL = {
  open: "Open (default)",
  listed: "Only what's listed",
} as const

/** The tooltip under the select, and the sentence the headline builds on. */
export function describeAccessMode(isClosed: boolean, subject: string) {
  return isClosed
    ? `Only what's listed: exactly the ${subject} their licenses include and the ones ticked below, nothing else. New ${subject} reach them only through a ticked header rule ("everything in …, now and in future releases").`
    : `Open: every ${singular(subject)} that is free for everyone, plus what their licenses include. New ${subject} arrive on their own; nothing to maintain.`
}

function singular(subject: string) {
  return subject.replace(/ies$/, "y").replace(/s$/, "")
}
